// useDoctors.js  ← exactly your original file name & style
import { useEffect, useState } from "react";
import { getDoctorsAndSpecialities } from "../services/masterDataService";

export const useDoctors = (companyId, domain) => {
  const [doctors, setDoctors] = useState([]);
  const [fullDoctors, setFullDoctors] = useState([]);   // ← we keep full data here
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!companyId || !domain) {
      setDoctors([]);
      setFullDoctors([]);
      return;
    }

    setLoading(true);

    getDoctorsAndSpecialities(companyId, domain)
      .then(function (data) {
        const doctorOptions = data?.map(function (c) {
          const speciality = c.procedures?.[0]?.procedureGroupName || "No Specialty";

          return {
            value: c.szDoctorId,
            label: `${c.szDoctorName} - ${speciality} - ${c.officeName || ''} - ${c.szDoctorId}`,
            ...c
          };
        });

        setDoctors(doctorOptions);
        setFullDoctors(data);   // ← save original objects
      })
      .catch(function () {
        setDoctors([]);
        setFullDoctors([]);
      })
      .finally(function () {
        setLoading(false);
      });
  }, [companyId, domain]);

  return { doctors, fullDoctors, loading };
};